<app-modal #modalRef [active]="active" [width]="1100" (modalClosed)="onModalClosed()">
  <div class="p-3">
    <div class="columns">
      <div class="column">
        <!-- STEP 1: Bauakten selection -->
        <form *ngIf="bauaktenForm && step === 1" [formGroup]="bauaktenForm">
          <div class="title is-4 has-text-centered is-bold color-darkblue">
            Bauakteneinsicht
            <p class="has-text-grey is-size-6">Bestellen Sie Ihre Bauakteneinsicht in wenigen Schritten</p>
          </div>
          <div class="title is-5 has-text-left is-darkblue">
            Bitte wählen Sie ein Produkt aus
          </div>

          <div class="mb-0"
               *ngFor="let bauakProduct of sortedBauakProducts(); index as i"
               [formGroup]="bauaktenForm.get('bauakSelections')">

            <!-- Main row: checkbox + price -->
            <div class="columns is-centered">
              <div class="column">
                <input [attr.document-name]="bauakProduct.nameShort"
                       id="checkbox_{{i+1}}"
                       type="checkbox"
                       class="custom-checkbox"
                       [formControlName]="bauakProduct.nameShort">
                <label for="checkbox_{{i+1}}" class="ml-1">
        <span class="is-bold has-text-grey-dark"
              [ngClass]="{'required': showInvalidInputs && !(bauaktenForm.get('bauakSelections')?.valid)}">
          {{ bauakProduct.name_long }}
        </span>
                </label>
              </div>
              <div class="column is-narrow">
      <span class="is-size-6 has-text-grey-dark has-background-light price-tag px-2 py-1 is-rounded">
        ab {{ bauakBasePrice }}€ netto
      </span>
              </div>
            </div>

            <!-- Subclasses row (independent, always underneath main row) -->
            <div class="columns is-multiline mt-2 ml-4"
                 *ngIf="isBauakPartSelected() && (pbauakKey === bauakProduct.nameShort)"
                 [formGroup]="bauaktenForm.get('bauakSubclasses')">

              <div class="column py-1"
                   *ngFor="let sub of bauakSubClasses; index as sIdx"
                   [ngClass]="'is-one-third'">

                <!-- Checkbox + Label -->
                <div class="is-flex" style="gap:8px; align-items:flex-start;">
                  <input type="checkbox" [id]="'pbauak_sub_'+sIdx"
                         class="custom-checkbox"
                         [formControlName]="sub.className"
                         style="margin-top:6px;">
                  <label [for]="'pbauak_sub_'+sIdx" style="margin:0;">
                    <span class="is-bold has-text-grey-dark"
                          [ngClass]="{ 'required': showInvalidInputs && (bauaktenForm.get('bauakSubclasses')?.invalid) }">
                      {{ sub.name }}
                    </span>
                  </label>
                </div>
              </div>

              <!-- Textarea for Sonstiges -->
              <div class="column is-12 mb-4" *ngIf="isSonstigesSelected()">
                <div class="text-area-container p-2 has-round-border has-box-shadow my-3"
                     [ngClass]="{ 'error-shadow': showInvalidInputs && (bauaktenForm.get('partDescription')?.invalid) }">
                  <p class="is-size-6 color-darkblue mb-3"
                     [ngClass]="{ 'required': showInvalidInputs && (bauaktenForm.get('partDescription')?.invalid) }">
                    Bitte beschreiben Sie die gewünschten Unterlagen
                    <span *ngIf="bauaktenForm && bauaktenForm.value.partDescription"
                          class="additional-text-information"
                          [ngClass]="{'required': bauaktenForm.value.partDescription.length > maxBauakInfoInput}">
                      {{ bauaktenForm.value.partDescription.length + ' / ' + maxBauakInfoInput + ' Zeichen' }}
                    </span>
                  </p>
                  <textarea
                      [formControl]="bauaktenForm.get('partDescription')"
                      cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="7"
                      class="w-100 no-border"
                      placeholder="Bitte beschreiben Sie die gewünschten sonstigen Unterlagen"></textarea>
                </div>
              </div>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <p class="is-size-6 has-text-grey has-text-weight-bold">Hinweis:</p>

              <div class="is-flex is-justify-content-space-between is-align-items-center">
                <p class="is-size-6 has-text-grey mb-0">
                  Bei einer notwendigen Vor-Ort Einsicht berechnen wir:
                </p>
                <span class="is-size-6 has-text-grey-dark price-tag">
                  zzgl. {{ bauakPricePerHour }} €/Std. netto
                </span>
              </div>
            </div>
          </div>

          <hr class="mt-2 mb-3">
          <div class="title is-5 has-text-left is-darkblue mb-1">
            Baujahr (optional)
          </div>
          <div class="columns mb-0">
            <div class="column">
              <div class="text-area-container p-2 has-round-border is-flex is-justify-content-center is-align-items-center has-box-shadow mt-3 mb-3">
                <textarea formControlName="constructionYear" cdkTextareaAutosize
                          cdkAutosizeMinRows="1"
                          cdkAutosizeMaxRows="7"
                          placeholder="Geben Sie das Baujahr des ursprünglichen Gebäudes sowie etwaige Erweiterungsjahre an."
                          class="w-100 no-border"
                          *ngIf="bauaktenForm">

                </textarea>
              </div>
            </div>
          </div>

          <div class="title is-5 has-text-left is-darkblue mb-1">
            Anmerkung (optional)
            <span *ngIf="bauaktenForm && bauaktenForm.value.additionalInfo" class="additional-text-information"
                  [ngClass]="{'required':bauaktenForm.value.additionalInfo.length > maxBauakInfoInput}">
              {{ bauaktenForm.value.additionalInfo.length + ' / ' + maxBauakInfoInput + ' Zeichen' }}
            </span>
          </div>
          <div class="columns">
            <div class="column">
              <div class="text-area-container p-2 has-round-border is-flex is-justify-content-center is-align-items-center has-box-shadow mt-3 mb-3">
                <textarea formControlName="additionalInfo" cdkTextareaAutosize
                          cdkAutosizeMinRows="1"
                          cdkAutosizeMaxRows="7"
                          placeholder="z.B. 'Bitte nur Unterlagen ab 1951.'" class="w-100 no-border"
                          *ngIf="bauaktenForm">
                </textarea>
              </div>
            </div>
          </div>
          <hr class="mt-2 mb-3">

          <div *ngIf="serviceCategories" class="title is-5 has-text-left is-darkblue mb-3">
            {{ getCategoryLongName(serviceCategories, "ABServices") }}
          </div>
          <div [formGroup]="bauaktenForm.get('abServices')"
               *ngFor="let service of bookableServicesByCategory.get('ABServices'); index as i"
               class="columns is-vcentered mb-0">

            <!-- Checkbox + label -->
            <div class="column">
              <input [attr.aBService-name]="service.shortName"
                     id="abservice_{{i+1}}"
                     type="checkbox"
                     class="custom-checkbox"
                     [formControlName]="service.shortName">
              <label for="abservice_{{i+1}}" class="ml-1">
                <span class="is-bold has-text-grey-dark">
                  {{ service.longName }}
                </span>
              </label>
            </div>

            <!-- Price tag -->
            <div class="column is-narrow">
              <span class="is-size-6 has-text-grey-dark price-tag">
                zzgl. {{ bauakPricePerHour }} €/Std. netto
              </span>
            </div>
          </div>
          <hr class="mt-2 mb-3">

          <div *ngIf="serviceCategories" class="title is-5 has-text-left is-darkblue mt-3">
            <p>{{ getCategoryLongName(serviceCategories, "CService") }} </p>
          </div>
          <div *ngFor="let service of bookableServicesByCategory.get('CService'); index as i" class="columns mb-0">
            <div class="column">
              <input [attr.cservice-name]="service.shortName" id="cservice_{{i+1}}" type="radio"
                     class="custom-radio" formControlName="cService"
                     [value]="service.shortName">
              <label for="cservice_{{i+1}}">
                              <span class="is-bold has-text-grey-dark"
                                    [ngClass]="{'required': showInvalidInputs && !bauaktenForm.value.cService}">
                                  {{ service.longName }}
                              </span>
              </label>
            </div>
          </div>

          <div class="columns mt-2">
            <div class="column">
              <p class="is-size-6 has-text-grey has-text-weight-bold">Hinweis:</p>
              <p class="is-size-6 has-text-grey mb-0">
                Sie können die bevorzugte Art der Aufnahmen angeben. Je nach Vorgaben der zuständigen Behörde ist jedoch
                ausschließlich die Anfertigung von Scans oder Fotografien zulässig. Durch die Scanqualität können
                weitere
                Gebühren der Behörde/ Dienstleister aufkommen.
              </p>
            </div>
          </div>

          <div *ngIf="isConnectOrigin" class="notification is-info is-light">
            <p class="is-size-6 has-text-weight-bold">Wichtiger Hinweis:</p>
            <p class="is-size-6">
              Zum Nachweis des berechtigten Interesses fordern die Behörden einen aktuellen Grundbuchauszug, welchen wir
              zur Vorlage beim Amt kostenlos (gegen Behördengebühr) organisieren.
            </p>
          </div>
        </form>

        <!-- STEP 2: Grunde information -->
        <div *ngIf="step === 2">
          <div class="title is-4 has-text-centered is-bold color-darkblue">
            Bauakteneinsicht
          </div>

          <div class="notification is-info is-light">
            <p class="is-size-6 has-text-weight-bold">Wichtiger Hinweis:</p>
            <p class="is-size-6">
              Zum Nachweis des berechtigten Interesses fordern die Behörden einen aktuellen Grundbuchauszug, welchen wir
              zur Vorlage beim Amt kostenlos (gegen Behördengebühr) organisieren.
            </p>
          </div>

          <ng-container>
            <p class="is-bold is-size-6 mt-4">Grundbuchblatt-Nr.</p>
            <app-folio-number [property]="selectedProperty"
                              [displayAdditionalCostInformation]="true"></app-folio-number>

            <p class="is-bold is-size-6 mt-4">Eigentümerdaten</p>
            <app-object-owner [property]="selectedProperty"></app-object-owner>
          </ng-container>
        </div>
      </div>
    </div>
    <!-- Footer actions -->
    <div class="columns" *ngIf="step === 1">
      <div class="column is-one-third">
        <a (click)="findBauaktenDocument() ? removeBauaktenDocument() :  null"
           class="button back-button is-size-6 has-round-border mb-1"
           style="border:none;" [ngClass]="{'disabled' : !findBauaktenDocument()}">
          <div class="columns" style="align-items: center;justify-content: center">
            <img src="assets/images/orders-icons/trash-can.svg" alt="Trashcan">
          </div>
        </a>
      </div>
      <div class="column is-one-third"></div>
      <div class="column is-one-third">
        <a (click)="isAllowedToOrder ? onSubmit() : $event.stopPropagation()" type="submit"
           class="button buy-button is-size-6 has-round-border mb-1" style="border:none; display: block!important;">
          <div class="columns" style="align-items: center;justify-content: center;padding-top: 5px">
            <div class="column is-bold"><p style="padding-left: 2rem; padding-bottom: 10px;">Weiter</p></div>
            <div class="column is-one-fifth" style="padding-left: 0">
              <img alt="Arrow Right" src="assets/images/button/right_btn.svg">
            </div>
          </div>
        </a>
      </div>
    </div>

    <div class="columns" *ngIf="step === 2">
      <div class="column is-one-third">
        <a (click)="backToStepOne()" class="button back-button is-size-6 has-round-border mb-1" style="border:none;">
          <div class="columns" style="align-items: center;justify-content: center">
            <img alt="Arrow Left" src="assets/images/button/left_btn.svg">
          </div>
        </a>
      </div>
      <div class="column is-one-third"></div>
      <div class="column is-one-third">
        <a (click)="isAllowedToOrder ? onConfirmGrunde() : $event.stopPropagation()"
           class="button buy-button is-size-6 has-round-border mb-1" style="border:none; display: block!important;">
          <div class="columns" style="align-items: center;justify-content: center;padding-top: 5px">
            <div class="column is-bold"><p style="padding-left: 2rem; padding-bottom: 10px;">Weiter</p></div>
            <div class="column is-one-fifth" style="padding-left: 0">
              <img alt="Arrow Right" src="assets/images/button/right_btn.svg">
            </div>
          </div>
        </a>
      </div>
    </div>

    <!-- Step indicator -->
    <div class="columns">
      <div class="column has-text-centered is-size-7 has-text-grey">
        {{ 'Schritt ' + (hasGrundeStep ? step : 1) + ' / ' + (hasGrundeStep ? 2 : 1) }}
      </div>
    </div>
  </div>
</app-modal>
